import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Option } from '@app/shared/interfaces/option';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html'
})
export class SelectComponent implements OnInit {
  @Output() selectionChange = new EventEmitter<any>();

  @Input() control!: FormControl;
  @Input() label = 'Select label';
  @Input() options!:Option[];
  @Input() requiredErrorMessage!: string;
  @Input() required:boolean = false;

  ngOnInit() {
  }

  handleChange() {
    this.selectionChange.emit(this.control.value);
  }
}
